module.exports = __webpack_public_path__ + "static/media/2 6 Ordkjedetest-Feil-hus-grei.ec4c2db4.mp3";